/* eslint-disable react/jsx-key */
import { useEffect, useState } from 'react';
import Footer from '@/components/Layout/Footer/Footer';
import proimg from '@/assets/pro-img.png';
import pror from '@/assets/pro-r-img.png';
import checks from '@/assets/pay.png';
import { ContentLayout } from '@/components/Layout';
import { Button } from '@/components/Elements';
import i18next from 'i18next';
import LawyerCards from './LawyerCards';
import RequestSend from './RequestSend';
import AcceptRequest from './AcceptRequest';
import Final from './Final';
import { useGetAcceptedRequestLawyer } from './lawyerList';
import LawyerAllRequests from './LawyerAllRequests';

export const LawyerRequests = () => {
  const [activeTab, setActiveTab] = useState('Accepted');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'Property':
        return <LawyerCards />;
      case 'Request':
        return <RequestSend />;
      case 'Accepted':
        return <LawyerAllRequests />;
      case 'Finalized':
        return <Final />;
      default:
        return null;
    }
  };
  return (
    <>
      <ContentLayout title={i18next.t('Lawyer Deals')}>
        <section className="inner-banner sub agency lawyer">
          <div
            className="faq-banner rounded-50 mx-3 "
            style={{ backgroundImage: `url(${proimg})` }}
          >
            <div className="bg-overlay py-md-3 px-md-5 p-3">
              <div className="container">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="profile-content">
                      <h2 className="fw-400 text-white f-40">Lawyer Requests</h2>
                      <p className="text-white fw-400">
                        A lawyer request is a formal document or message addressed to organizations
                        or individuals, asking for information or action necessary to protect a
                        client’s rights, such as details about a case, evidence, or legal
                        documentation. It must be clear, specific, and usually includes the reason
                        for the request and relevant legal references.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="pro-right-img ">
                      <img src={pror} alt="img" className="img-fluid w-75 ms-auto" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="agency-tabssec">
          <div className="container">
            <div className="agency-tab-btns">
              {/* <div className="agency-filter-tb gap-2 d-flex align-items-center">
                <Button
                  className={activeTab === 'Property' ? 'active' : ''}
                  onClick={() => setActiveTab('Property')}
                >
                  Property Listing
                </Button>
                <Button
                  className={activeTab === 'Request' ? 'active' : ''}
                  onClick={() => setActiveTab('Request')}
                >
                  Requested Agency
                </Button>
                <Button
                  className={activeTab === 'Accepted' ? 'active' : ''}
                  onClick={() => setActiveTab('Accepted')}
                >
                  Accepted Request
                </Button>
                <Button
                  className={activeTab === 'Finalized' ? 'active' : ''}
                  onClick={() => setActiveTab('Finalized')}
                >
                  Finalized 
                </Button>
              </div> */}
              <div className="filtred-agency-content">{renderTabContent()}</div>
            </div>
          </div>
        </section>
        <Footer />
      </ContentLayout>
    </>
  );
};
